var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-body" },
    [
      _vm.componentStatus && _vm.componentStatus.personalExperience
        ? [
            _c(
              "div",
              { staticClass: "from-item-title mb15" },
              [
                _c("span", { staticClass: "title" }, [_vm._v("工作经历")]),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    attrs: { underline: false, icon: "el-icon-plus" },
                    on: {
                      click: function ($event) {
                        return _vm.editWorks("work")
                      },
                    },
                  },
                  [_vm._v("添加经历")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("tableBox", {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: {
                    id: _vm.id,
                    "table-data": _vm.workData,
                    "table-label": _vm.workLabel,
                    type: _vm.edit,
                    "table-name": "works",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "from-item-title mb15" },
              [
                _c("span", { staticClass: "title" }, [_vm._v("教育经历")]),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    attrs: { underline: false, icon: "el-icon-plus" },
                    on: {
                      click: function ($event) {
                        return _vm.editEducation("education")
                      },
                    },
                  },
                  [_vm._v("添加经历")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("tableBox", {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: {
                    id: _vm.id,
                    "table-data": _vm.educationsData,
                    "table-label": _vm.educationLabel,
                    type: _vm.edit,
                    "table-name": "education",
                  },
                }),
              ],
              1
            ),
          ]
        : _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.fromRules,
                "label-width": "90px",
              },
            },
            _vm._l(_vm.newFrom, function (formItem, itemIndex) {
              return _c(
                "div",
                { key: itemIndex, staticClass: "p20" },
                [
                  _vm.componentStatus.type === "add" ||
                  !["工作经历", "教育经历"].includes(formItem.title)
                    ? _c(
                        "div",
                        {
                          staticClass: "from-item-title",
                          class:
                            _vm.FORMITEMISEDIT[itemIndex] &&
                            _vm.componentStatus.type === "edit"
                              ? "m10"
                              : "mb15",
                          attrs: { id: itemIndex },
                        },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(formItem.title) +
                                "\n          "
                            ),
                            _vm._v(" "),
                            formItem.title === "银行卡信息" &&
                            _vm.user === "个人简历"
                              ? _c("span", { staticClass: "text-title" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(
                                    "\n            银行卡信息为敏感信息，右侧简历不会发送给其他企业"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            formItem.title === "社保信息" &&
                            _vm.user === "个人简历"
                              ? _c("span", { staticClass: "text-title" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(
                                    "\n            社保信息为敏感信息，右侧简历不会发送给其他企业"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            formItem.title === "个人材料" &&
                            _vm.user === "个人简历"
                              ? _c("span", { staticClass: "text-title" }, [
                                  _c("i", { staticClass: "el-icon-warning" }),
                                  _vm._v(
                                    "\n            个人材料为敏感信息，右侧简历不会发送给其他企业\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.FORMITEMISEDIT[itemIndex] &&
                          _vm.componentStatus.type === "edit"
                            ? _c(
                                "span",
                                { staticClass: "editBtn" },
                                [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        underline: false,
                                        icon: "el-icon-edit-outline",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.FORMITEMISEDIT[itemIndex] =
                                            !_vm.FORMITEMISEDIT[itemIndex]
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.FORMITEMISEDIT[itemIndex]
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.restFn(itemIndex)
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.formItemEdit(
                                            formItem.edit_type,
                                            itemIndex
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          ["工作经历", "教育经历"].includes(formItem.title)
                            ? _c("span", [
                                _c(
                                  "div",
                                  { staticStyle: { padding: "10px" } },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          underline: false,
                                          icon: "el-icon-plus",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addWorks(formItem.title)
                                          },
                                        },
                                      },
                                      [_vm._v("添加经历")]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  formItem.slot === "workExperience" &&
                  _vm.componentStatus.type === "add"
                    ? _c("tableBox", {
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: {
                          "person-id": _vm.personId,
                          "table-data": _vm.workData,
                          "table-label": _vm.workLabel,
                          type: (_vm.edit = "add"),
                          user: _vm.user,
                          "table-name": "works",
                        },
                        on: {
                          deleteWork: _vm.deleteWork,
                          putWork: _vm.putWork,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  formItem.slot === "educationalExperience" &&
                  _vm.componentStatus.type === "add"
                    ? _c("tableBox", {
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: {
                          "person-id": _vm.personId,
                          "table-data": _vm.educationsData,
                          "table-label": _vm.educationLabel,
                          type: (_vm.edit = "add"),
                          user: _vm.user,
                          "table-name": "education",
                        },
                        on: {
                          deleteWork: _vm.deleteWork,
                          putWork: _vm.putWork,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-box" },
                    _vm._l(formItem.data, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "form-item" },
                        [
                          _c(
                            "el-form-item",
                            {
                              class:
                                _vm.FORMITEMISEDIT[itemIndex] &&
                                _vm.componentStatus.type === "edit" &&
                                item.type !== "uploadImg"
                                  ? "activeItem"
                                  : "",
                              attrs: { prop: item.value },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class:
                                    _vm.FORMITEMISEDIT[itemIndex] &&
                                    _vm.componentStatus.type === "edit"
                                      ? "label"
                                      : "labelfont",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [_vm._v(_vm._s(item.label))]
                              ),
                              _vm._v(" "),
                              _vm.FORMITEMISEDIT[itemIndex] &&
                              _vm.componentStatus.type === "edit" &&
                              item.type !== "uploadImg"
                                ? _c(
                                    "div",
                                    { staticClass: "label-item" },
                                    [
                                      ![
                                        "cascader",
                                        "frame_id",
                                        "manage_frame",
                                      ].includes(item.slot) &&
                                      !["radio", "select"].includes(item.type)
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.ruleForm[item.value])
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "frames"
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.rangeUserText,
                                              function (item, index) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [_vm._v(_vm._s(item) + " ")]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "cascader"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.positionText)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "manage_frame"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.manage_frameText)
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.value === "is_part"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.is_partText)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.value === "type"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.typeText)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.value === "sex"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.sexText)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.value === "marriage"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.marriageText)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.value === "education"
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.educationText)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "radio"
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.is_adminText) +
                                                "\n              "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "superior_uid" &&
                                      _vm.is_adminText === "是"
                                        ? [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.superiorText)),
                                            ]),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "frame_id"
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.frameText,
                                              function (item, index) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: index,
                                                    staticClass: "mr5",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.name) + " "
                                                    ),
                                                    item.is_mastart
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#1890ff",
                                                              "font-size":
                                                                "13px",
                                                            },
                                                          },
                                                          [_vm._v(" (主) ")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _c(
                                    "div",
                                    [
                                      item.type === "input"
                                        ? _c("el-input", {
                                            attrs: {
                                              placeholder: item.placeholder,
                                              size: "small",
                                              clearable: "",
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.getBirthday(
                                                  item.value
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.ruleForm[item.value],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  item.value,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ruleForm[item.value]",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type == "num"
                                        ? _c("el-input-number", {
                                            attrs: {
                                              max: 999999,
                                              min: 1,
                                              size: "small",
                                              "controls-position": "right",
                                            },
                                            model: {
                                              value: _vm.ruleForm[item.value],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  item.value,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ruleForm[item.value]",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "date"
                                        ? _c("el-date-picker", {
                                            attrs: {
                                              placeholder: item.placeholder,
                                              type: "date",
                                              size: "small",
                                              "value-format": "yyyy-MM-dd",
                                            },
                                            model: {
                                              value: _vm.ruleForm[item.value],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  item.value,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ruleForm[item.value]",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "cascader"
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "flx" },
                                              [
                                                _c("el-cascader", {
                                                  attrs: {
                                                    options: _vm.treeData,
                                                    placeholder:
                                                      item.placeholder,
                                                    props: _vm.propsPos,
                                                    filterable: "",
                                                    size: "small",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.ruleForm.position,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.ruleForm,
                                                        "position",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "ruleForm.position",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-plus",
                                                  on: { click: _vm.addQuick },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "frame_id"
                                        ? _c("select-department", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              value: _vm.frames || [],
                                              "is-site": true,
                                              placeholder: "选择所属部门",
                                            },
                                            on: {
                                              changeMastart: _vm.changeMastart,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "radio"
                                        ? [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: "1" },
                                                model: {
                                                  value:
                                                    _vm.ruleForm[item.value],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      item.value,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ruleForm[item.value]",
                                                },
                                              },
                                              [_vm._v("是")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: "0" },
                                                model: {
                                                  value:
                                                    _vm.ruleForm[item.value],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      item.value,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ruleForm[item.value]",
                                                },
                                              },
                                              [_vm._v("否")]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot == "superior_uid"
                                        ? _c(
                                            "div",
                                            [
                                              _c("select-member", {
                                                ref: "selectMember",
                                                refInFor: true,
                                                attrs: {
                                                  "only-one": true,
                                                  value: _vm.superiorUser || [],
                                                },
                                                on: {
                                                  getSelectList:
                                                    _vm.getSelectList,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "custom",
                                                      fn: function () {
                                                        return [
                                                          _vm.superiorUser
                                                            .length == 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pointer",
                                                                  staticStyle: {
                                                                    color:
                                                                      "#1890ff",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.handlesuperiorOpen,
                                                                  },
                                                                },
                                                                [_vm._v("添加")]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      _vm.handlesuperiorOpen,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .superiorUser[0]
                                                                          .name
                                                                      ) +
                                                                      "\n                    "
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm._v(" "),
                                                          _vm.superiorUser
                                                            .length > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pointer ml10",
                                                                  staticStyle: {
                                                                    color:
                                                                      "#1890ff",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.handlesuperiorOpen,
                                                                  },
                                                                },
                                                                [_vm._v("修改")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot == "manage_frame"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "请选择",
                                                    size: "small",
                                                    disabled:
                                                      _vm.ruleForm.is_admin !=
                                                      1,
                                                    multiple: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.ruleForm.manage_frame,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.ruleForm,
                                                        "manage_frame",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "ruleForm.manage_frame",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.frames,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "select"
                                        ? _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.tabtypes !== 1 &&
                                                  item.value == "type",
                                                placeholder: item.placeholder,
                                                size: "small",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.ruleForm[item.value],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.ruleForm,
                                                    item.value,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "ruleForm[item.value]",
                                              },
                                            },
                                            _vm._l(
                                              item.optionsList,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "uploadImg"
                                        ? _c("upload-image", {
                                            attrs: {
                                              "append-to-body": true,
                                              imageUrl:
                                                _vm.ruleForm[item.value],
                                              isUploadStatus:
                                                _vm.componentStatus.type ===
                                                  "edit" &&
                                                _vm.FORMITEMISEDIT[itemIndex],
                                              user: _vm.user,
                                            },
                                            on: {
                                              "update:imageUrl": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.ruleForm,
                                                  item.value,
                                                  $event
                                                )
                                              },
                                              "update:image-url": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.ruleForm,
                                                  item.value,
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.slot === "radio"
                                        ? [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.componentStatus.type ===
                                                      "edit" &&
                                                    _vm.FORMITEMISEDIT[
                                                      itemIndex
                                                    ],
                                                  label: "1",
                                                },
                                                model: {
                                                  value: _vm.ruleForm.radio,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      "radio",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "ruleForm.radio",
                                                },
                                              },
                                              [_vm._v("直接加入")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.componentStatus.type ===
                                                      "edit" &&
                                                    _vm.FORMITEMISEDIT[
                                                      itemIndex
                                                    ],
                                                  label: "2",
                                                },
                                                model: {
                                                  value: _vm.ruleForm.radio,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      "radio",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "ruleForm.radio",
                                                },
                                              },
                                              [_vm._v("后续邀请")]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            }),
            0
          ),
      _vm._v(" "),
      _c("Addwork", {
        ref: "refwork",
        attrs: { add: _vm.add, "append-to-body": true, edit: _vm.editTable },
        on: { addWorkFn: _vm.addWorkFn },
      }),
      _vm._v(" "),
      _c("position-dialog", {
        ref: "positionDialog",
        attrs: { config: _vm.positionConfig },
        on: { handleConfig: _vm.handleConfig },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }